import React from 'react'
import { graphql } from '@apollo/client/react/hoc'
import { gql } from '@apollo/client'
import { Loading } from '@website2018/da-dobsonville'
import PeopleTemplate from '../../components/People/PeopleTemplate'

class PeopleContainer extends React.Component {
  render() {
    const { loading, error, page: p } = this.props
    // const { site } = this.props;
    // const { province: page } = site;

    if (loading) return <Loading />
    if (error || !p) return <p>{error}</p>

    return <PeopleTemplate {...this.props} />
  }
}

const PEOPLE_QUERY = gql`
  query getPeople($slug: String!) {
    page(slug: $slug) {
      id
      slug
      seo
      hero {
        headline
        cta_type
        cta_group {
          title
          link_label
          link_url
        }
        background_image {
          url
        }
        focus_point
      }
      acf
      meta {
        people {
          heading
          connected {
            id
            slug
            rawTitle
            title {
              rendered
            }
            excerpt {
              rendered
            }
            role
            facebook
            twitter
            featured_media {
              id
              source_url
              title {
                rendered
              }
            }
          }
        }
      }
      highlight {
        person {
          id
          slug
          title {
            rendered
          }
          excerpt {
            rendered
          }
          role
          facebook
          twitter
          featured_media {
            id
            source_url
            title {
              rendered
            }
          }
        }
      }
      excerpt {
        rendered
      }
      title {
        rendered
      }
      content {
        rendered
      }
      parent {
        slug
        title {
          rendered
        }
        content {
          rendered
        }
        children {
          id
          slug
          title {
            rendered
          }
        }
      }
      children {
        id
        slug
        title {
          rendered
        }
      }
    }
  }
`

const withPeople = graphql(PEOPLE_QUERY, {
  options: props => {
    return {
      variables: {
        slug: 'our-people'
      }
    }
  },
  props: ({ data }) => ({ ...data })
})

export default withPeople(PeopleContainer)
